import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";


// LOGIN
export const AdminLogin = async (credentials) =>
  commonFetch(API_URLS.ADMIN_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const StudentLogin = async (credentials) =>
  commonFetch(API_URLS.STUDENT_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const EmployeeLogin = async (credentials) =>
  commonFetch(API_URLS.EMPLOYEE_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const ParentLogin = async (credentials) =>
  commonFetch(API_URLS.PARENT_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

export const login = async (credentials) =>
  commonFetch(API_URLS.AUTH_LOGIN_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });

// SIGNUP
export const signup = async (formData) =>
  commonFetch(API_URLS.SIGNUP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

// FORGOT PASSWORD AND CHANGE PASSWORD
export const employeeForgotPassword = async (formData) =>
  commonFetch(API_URLS.EMPLOYEE_FORGOT_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const employeeChangePassword = async (formData) =>
  commonFetch(API_URLS.EMPLOYEE_CHANGE_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const adminForgotPassword = async (formData) =>
  commonFetch(API_URLS.ADMIN_FORGOT_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const adminResetExpiredPassword = async (formData) =>
  commonFetch(API_URLS.ADMIN_RESET_EXPIRED_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const adminResetExpiredPasswordOtp = async (formData) =>
  commonFetch(API_URLS.ADMIN_RESET_EXPIRED_PASSWORD_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const adminChangePassword = async (formData) =>
  commonFetch(API_URLS.ADMIN_CHANGE_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
  export const studentForgotPassword = async (formData) =>
  commonFetch(API_URLS.STUDENT_FORGOT_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const studentChangePassword = async (formData) =>
  commonFetch(API_URLS.STUDENT_CHANGE_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const parentChangePassword = async (formData) =>
  commonFetch(API_URLS.PARENT_CHANGE_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const parentForgotPassword = async (formData) =>
  commonFetch(API_URLS.PARENT_FORGOT_PASSWORD_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

// VERIFY OTP
export const employeeVerifyOtp = async (formData) =>
  commonFetch(API_URLS.EMPLOYEE_VERIFY_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

export const adminVerifyOtp = async (formData) =>
  commonFetch(API_URLS.ADMIN_VERIFY_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
export const DefaultChangePasswordVerifyOtp = async (formData) =>
  commonFetch(API_URLS.DEFAULTCHANGEPASSWORD_VERIFY_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

export const studentVerifyOtp = async (formData) =>
  commonFetch(API_URLS.STUDENT_VERIFY_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

export const parentVerifyOtp = async (formData) =>
  commonFetch(API_URLS.PARENT_VERIFY_OTP_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
